import React from "react";
import YouTube from "react-youtube";
import ReactLinkify from "react-linkify";

import { PAYMENT_STATUS } from "../const/profileConstants";

export const ShowcaseProjectItem = (props) => {
  const { heading, description, url, paymentStatus, isAssignment } = props;

  const renderProjectBadges = (text) => {
    let className = "";

    switch (text) {
      case "My University Assignment":
        className = "assignment";
        break;
      case PAYMENT_STATUS.PAID:
        className = "paid";
        break;
      case PAYMENT_STATUS.PARTIAL_PAID:
        className = "partial-paid";
        break;
      default:
        className = "";
    }

    return text && <div className={`project-badge ${className}`}>{text}</div>;
  };

  return (
    <div className="showcase-item-inner bg-light">
      <div className="inner-wrapper d-flex">
        <div className="video-wrapper">
          <YouTube videoId={url} opts={{ height: "180px", width: "30rem" }} />
        </div>
        <div className="desc-wrapper">
          <div className="project-header">
            <b>{heading}</b>
            {renderProjectBadges(paymentStatus)}
            {isAssignment && renderProjectBadges("My University Assignment")}
          </div>
          <div className="project-description">
            <ReactLinkify>{description}</ReactLinkify>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ShowcaseProjectItem;
